import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { CustomBannerComponent } from './custom-banner.component';

@NgModule({
  declarations: [CustomBannerComponent],
  imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule],
  providers: [
    provideConfig({
      cmsComponents: {
        SimpleResponsiveBannerComponent: {
          component: () =>
            import('./custom-banner.component').then(
              (m) => m.CustomBannerComponent
            ),
        },
        BannerComponent: {
          component: () =>
            import('./custom-banner.component').then(
              (m) => m.CustomBannerComponent
            ),
        },
        SimpleBannerComponent: {
          component: () =>
            import('./custom-banner.component').then(
              (m) => m.CustomBannerComponent
            ),
        },
      },
    } as CmsConfig),
  ],
})
export class CustomBannerModule {}
